var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74538 18C7.74538 16.8568 7.93525 15.7608 8.27413 14.7328L2.34252 10.2032C1.18648 12.5504 0.535156 15.1952 0.535156 18C0.535156 20.8024 1.18568 23.4456 2.34012 25.7912L8.26853 21.2528C7.93285 20.2296 7.74538 19.1376 7.74538 18Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1599 7.59998C20.6434 7.59998 22.8866 8.47998 24.6491 9.91998L29.7764 4.79998C26.652 2.07998 22.6463 0.399979 18.1599 0.399979C11.1948 0.399979 5.20875 4.38318 2.34229 10.2032L8.2739 14.7328C9.64064 10.584 13.5366 7.59998 18.1599 7.59998Z",
    fill: "#EB4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1599 28.4C13.5366 28.4 9.64064 25.416 8.2739 21.2672L2.34229 25.796C5.20875 31.6168 11.1948 35.6 18.1599 35.6C22.4588 35.6 26.563 34.0736 29.6434 31.2136L24.013 26.8608C22.4244 27.8616 20.4239 28.4 18.1599 28.4Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.984 18C34.984 16.96 34.8238 15.84 34.5835 14.8H18.1602V21.6H27.6136C27.1409 23.9184 25.8543 25.7008 24.0133 26.8608L29.6436 31.2136C32.8794 28.2104 34.984 23.7368 34.984 18Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.9192cc00c2ca0fd4f4ff0ceb23bb4ac5.svg";
export { ForwardRef as ReactComponent };